import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Icon from '../../../common/icons/Icon';
import VideoPlayer from '../../../common/video/VideoPlayer';

class VideoHint extends Component {
  static propTypes = {
    initialTime: PropTypes.number.isRequired,
    toggleVideoHintOpen: PropTypes.func.isRequired,
    video: PropTypes.object,
    videoHintOpen: PropTypes.bool,
  };

  defaultProps = {
    videoHintOpen: false,
  };

  render() {
    const { videoHintOpen, initialTime, toggleVideoHintOpen, video } = this.props;

    if (!videoHintOpen) {
      return (
        <div>
          <button type="button" className="button button--icon button--theme--plain" onClick={toggleVideoHintOpen}>
            <Icon icon="Replay" />
            Get a video hint
          </button>
        </div>
      );
    }

    return (
      <div className="video-hint">
        <button type="button" className="video-hint__button button--icon" onClick={toggleVideoHintOpen}>
          <Icon icon="Close" />
        </button>
        <VideoPlayer video={video} initialTime={initialTime} autoplay />
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  video: state.subscription.courses.lessonVideo.get('data'),
});

export default connect(mapStateToProps)(VideoHint);



// WEBPACK FOOTER //
// ./src/subscription/courses/components/VideoHint.js